import { styled } from '@mui/system';
import { Button } from '@mui/base/Button';
import { Box, Typography, TableContainer, IconButton } from '@mui/material';

export const WeekTitle = styled(Typography)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  color: theme.palette.text.primary,
}));

export const NoShiftsText = styled(Typography)(({ theme }) => ({
  textAlign: 'center',
  padding: theme.spacing(2),
  color: theme.palette.text.secondary,
}));

export const ScheduleContainer = styled(TableContainer)(({ theme }) => ({
  background: theme.palette.primary.main,
  borderRadius: theme.spacing(1.5),
  display: 'flex',
  padding: 0,
  margin: 0,
  flexDirection: 'column',
  cursor: 'pointer',
  width: '100%',
  listStyle: 'none',
  minWidth: 'fit-content',
  overflow: 'auto',
}));

export const ActionsContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'end',
  width: '100%',
  gap: theme.spacing(1),
  flex: 1,
}));

export const StyledIconButton = styled(IconButton)(() => ({
  color: 'white',
}));

export const TitleContainer = styled(Box)(() => ({
  width: '100%',
}));

export const StyledAction = styled(Button)(({ theme }) => ({
  color: theme.palette.text.primary,
  background: 'transparent',
  width: '100%',
  display: 'flex',
  border: 'none',
  padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
  cursor: 'pointer',
  borderRadius: theme.spacing(2),
  alignItems: 'center',
  justifyContent: 'space-between',
  ':disabled': {
    opacity: .5,
  },
  '&:hover': {
    background: theme.palette.primary.dark,
  }
}));
